import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { transientOptions } from "@product/scmp-sdk";

import { ArticleSpeechInlineWidget } from "~/components/article/article-speech";
import { IconWrapper } from "~/components/article/article-speech/article-speech-inline-widget/variants/generic/empty-button/styles";
import { ContentShareWidget } from "~/components/content/content-share-widget";
import { ZIndexLayer } from "~/lib/styles";

export const Container = styled.aside`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;

  inline-size: min-content;
`;

export type ContentShareWidgetProps = {
  $direction: "column" | "row";
  $outlineColor?: string;
};

export const StyledArticleSpeechInlineWidget = styled(ArticleSpeechInlineWidget)`
  margin-block-end: 28px;

  border-block-end: 1px solid #aaaaaa;

  ${IconWrapper} {
    margin-block-end: 8px;
  }
`;

export const StyledContentShareWidget = styled(ContentShareWidget, {
  ...transientOptions,
})<ContentShareWidgetProps>(
  props => css`
    position: relative;

    display: flex;
    flex-flow: ${props.$direction};
    gap: 16px;
    justify-content: flex-start;
    align-items: center;

    > [role="tooltip"] {
      z-index: ${ZIndexLayer.AppBar - 1};
    }

    ${props.$outlineColor &&
    css`
      button > * {
        border: 1px solid ${props.$outlineColor};
      }
    `}
  `,
);
